import React from 'react';
import styled from "styled-components";
import Card from '@mui/material/Card';

const WrapperStyled = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  width: 100%;
  grid-gap: 40px;
`;

const ItemStyled = styled.div`
  padding: 20px;
`;

const LabelStyled = styled.div`
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
`;

const ValueStyled = styled.div`
  font-size: 50px;
  line-height: 1;
  font-weight: 300;
`;

const Stats = ({items}) => {
    return (
        <WrapperStyled>
            {items.map((item, idx) => {
                return (
                    <Card
                        sx={{
                            boxShadow: "rgba(0, 0, 0, 0.05) 0rem 1.25rem 1.6875rem 0rem"
                        }}
                        key={item.label + idx}>
                        <ItemStyled>
                            <LabelStyled>{item.label}</LabelStyled>
                            <ValueStyled>{item.value}</ValueStyled>
                        </ItemStyled>
                    </Card>
                );
            })}
        </WrapperStyled>
    );
};

export default Stats;